import { referenceMessage } from '../common/contact';
import { EstateType, getThorViewEventProps, thorPushEvent } from '../common/thor';
import Wa from '../common/wa';

function initReferenceMessage() {
    const $container = $('[data-message-modal-content]');
    const $form = $container.find('[data-message-form]');
    const { gaCategory, waSource, gaLabelPrefix } = MA?.Context;
    const source = waSource || gaLabelPrefix;

    referenceMessage(
        $container,
        {
            category: gaCategory,
            actionPrefix: 'dde:form',
            label: 'past_sale:dde:form',
        },
        {
            key: 'form_success',
            name: 'realtor_contact',
            data: `source=${Wa.updateSourceWhenRetargeting(
                source,
            )}:past_sales_list|realtor_id=${$form.data('realtor-id')}|reference_id=${$form.data(
                'reference-id',
            )}`,
        },
        {
            key: 'page_view:past_sale',
            name: `${gaLabelPrefix}:past_sales_list`,
            data: `source=${source}|realtor_id=${$form.data(
                'realtor-id',
            )}|reference_id=${$form.data('reference-id')}`,
        },
    );
}

export function domReady() {
    const {
        // eslint-disable-next-line camelcase
        reference: { id, item_type, zip, city },
    } = MA.Context;
    thorPushEvent('page_view', {
        ...getThorViewEventProps('sold_properties', 'sold_property_agency_detail'),
        av_zip_code: zip,
        av_city: city.name,
        av_estate_type_global: EstateType[item_type.key],
        av_distribution_type_global: '2',
        av_items: {
            id: id.toString(),
            list_name: 'sold_products',
            estate_type: EstateType[item_type.key],
            publication_id: 'MA',
            name: 'sold_property',
            zip_code: zip,
            city: city.name,
            country: 'france',
        },
    });
    Wa.setTracking();
    initReferenceMessage();
}
